import $axios from '~/plugins/axios';

import { Api, CampaignBrief, GetCampaignBriefParams, PaginatorResult } from '~/api';
import { buildModule, createFiltersModule, createPaginationModule, defineSingleFilter } from '../utils';
import { Dict, createDict, fetchAllPages } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		filters: createFiltersModule({
			filters: {
				searchTerm: defineSingleFilter('search', String),
				monthIso: defineSingleFilter('month', String),
				printerId: defineSingleFilter('printer', Number),
				type: defineSingleFilter('type', String),
				campaignVisualId: defineSingleFilter('campaignVisual', Number),
			},
		}),
		pagination: createPaginationModule({
			pageQueryKey: 'campaignBriefsPage',
			pageSizeQueryKey: 'campaignBriefsPerPage',
			itemCountGetter: 'campaignBriefs/list/totalCount',
		}),
	})
	.withState({
		storedCampaignBriefs: {} as Dict<CampaignBrief>,
		campaignBriefs: [] as CampaignBrief[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (id: number): CampaignBrief | null => (
			state.storedCampaignBriefs[id] ?? null
		),
		page: state => state.campaignBriefs,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
		storedCampaignBriefs: state => state.storedCampaignBriefs,
	})
	.withMutations({
		SET_STORED_CAMPAIGN_BRIEFS (state, briefs: CampaignBrief[]) {
			state.storedCampaignBriefs = {
				...state.storedCampaignBriefs,
				...createDict(briefs, (brief) => brief.id),
			};
		},
		SET_CAMPAIGN_BRIEFS (state, briefIds: number[]) {
			state.campaignBriefs = briefIds.map(id => state.storedCampaignBriefs[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetCampaignBriefParams) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/campaign-brief', { params });
			commit('SET_LOADING', false);

			const briefs = data.payload;
			const briefIds = briefs.map(brief => brief.id);

			commit('SET_STORED_CAMPAIGN_BRIEFS', briefs);
			commit('SET_CAMPAIGN_BRIEFS', briefIds);
			commit('SET_PAGINATOR', data.paginator);
		},
		async getAll ({ commit }, params: GetCampaignBriefParams) {
			commit('SET_LOADING', true);
			const data = await fetchAllPages('/campaign-brief', params)<CampaignBrief>(api);
			commit('SET_LOADING', false);
			commit('SET_STORED_CAMPAIGN_BRIEFS', data);
			commit('SET_CAMPAIGN_BRIEFS', data.map(brief => brief.id));
		},
	});

